export default {
  mimeTypeSettingsHeader: '{mimeType} Settings',
  contentTypeSettingsHeader: 'Content settings',
  title: 'Export {mimeType}',
  submitLabel: 'Export {mimeType}',
};
